/* AMS colour siblings — product page label preview + collection card colour preview */
if (!customElements.get('ams-colour-siblings')) {
  customElements.define('ams-colour-siblings', class AmsColourSiblings extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-ams-sibling]'));
      if (!this.items.length) return;
      this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      this.dataset.mode === 'card' ? this.initCard() : this.initProduct();
    }

    /* ---------- Product page: swatches are plain links; hover previews the colour name ---------- */
    initProduct() {
      const label = this.querySelector('[data-ams-colour-name]');
      if (!label || !this.canHover) return;
      this.items.forEach((item) => {
        item.addEventListener('mouseenter', () => { label.textContent = item.dataset.colour; });
        item.addEventListener('mouseleave', () => { label.textContent = label.dataset.default; });
      });
    }

    /* ---------- Collection card: preview a colour in place, click opens that colour's product ---------- */
    initCard() {
      this.card = this.closest('product-card');
      if (!this.card) return;
      this.original = this.items.find((item) => item.classList.contains('is-active')) || this.items[0];
      this.current = this.original;

      this.items.forEach((item) => {
        if (this.canHover) item.addEventListener('mouseenter', () => this.preview(item));
        item.addEventListener('click', (event) => {
          // Touch: first tap previews, second tap on the same swatch navigates
          if (!this.canHover && item !== this.current) {
            event.preventDefault();
            this.preview(item);
          }
        });
      });
    }

    preview(item) {
      if (item === this.current) return;
      const d = item.dataset;
      const card = this.card;

      const img = card.querySelector('[data-product-card-image]');
      if (img && d.imgSrc) {
        img.removeAttribute('loading');
        img.srcset = d.imgSrcset || '';
        img.src = d.imgSrc;
      }

      const secondary = card.querySelector('.product-card__image--secondary');
      if (secondary) {
        const secondaryImg = secondary.querySelector('img');
        if (d.img2Src && secondaryImg) {
          secondaryImg.srcset = d.img2Srcset || '';
          secondaryImg.src = d.img2Src;
          secondary.style.removeProperty('display');
        } else {
          secondary.style.display = 'none';
        }
      }

      if (d.url) {
        card.querySelectorAll('[data-product-card-link]').forEach((link) => { link.href = d.url; });
        card.dataset.productUrl = d.url;
      }

      const titleLink = card.querySelector('.product-grid--title a');
      if (titleLink && d.title) titleLink.textContent = d.title;
      const imageLink = card.querySelector('.grid__image');
      if (imageLink && d.title) imageLink.title = d.title;

      const priceTemplate = item.querySelector('template[data-ams-price]');
      const price = card.querySelector('.product-grid--price');
      if (priceTemplate && price) price.innerHTML = priceTemplate.innerHTML;

      card.classList.toggle('ams-sibling-preview', item !== this.original);

      this.items.forEach((el) => {
        const active = el === item;
        el.classList.toggle('is-active', active);
        active ? el.setAttribute('aria-current', 'true') : el.removeAttribute('aria-current');
      });
      this.current = item;
    }
  });
}
